import React from 'react';

import type CardStyling from '../models/CardStyling';
import { type CardStylingTypesEnum_value } from 'components/framework/models/generated/types';

type CardStylingMenuProps = {
  availableCardStylings: (typeof CardStyling)[];
  selected: CardStylingTypesEnum_value;
  onChange: Function;
};

const CardStylingMenu: React.FC<CardStylingMenuProps> = ({
  availableCardStylings,
  selected,
  onChange,
}) => {
  return (
    <aha-menu submenu>
      <aha-button kind='link' slot='control'>
        Card highlight
      </aha-button>
      <aha-menu-content>
        {availableCardStylings.map(CardStylingClass => (
          <aha-menu-item tabIndex={-1} key={CardStylingClass.type}>
            <aha-button
              kind='link'
              role='button'
              onClick={() => onChange(CardStylingClass.type)}
            >
              <input
                type='radio'
                style={{ alignSelf: 'center' }}
                checked={CardStylingClass.type === selected}
                readOnly
              />
              {CardStylingClass.title}
            </aha-button>
          </aha-menu-item>
        ))}
      </aha-menu-content>
    </aha-menu>
  );
};

export default CardStylingMenu;
